import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';
import App from './App';
import { enableContentProtection } from './lib/contentProtection';
enableContentProtection();

// After a deploy, hashed chunks from the previous build disappear; a tab (or
// cached index.html) that still references them fails with a ChunkLoadError
// or "Unexpected token '<'" (the host answered with HTML). Reload once to pick
// up the new build; the sessionStorage flag stops a reload loop if the chunk
// is genuinely missing.
const CHUNK_RELOAD_KEY = 'udyam_chunk_reload_at';
function reloadOnChunkError(message) {
    if (!/ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|Unexpected token '<'|Failed to fetch dynamically imported module/i.test(message || ''))
        return;
    try {
        const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
        if (Date.now() - last < 60000)
            return;
        sessionStorage.setItem(CHUNK_RELOAD_KEY, String(Date.now()));
    }
    catch {
        return; // storage unavailable: skip rather than risk a reload loop
    }
    window.location.reload();
}
window.addEventListener('error', (e) => reloadOnChunkError(e.message));
window.addEventListener('unhandledrejection', (e) => reloadOnChunkError(e.reason?.name === 'ChunkLoadError' ? 'ChunkLoadError' : String(e.reason?.message || e.reason || '')));
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode>
    <App />
  </React.StrictMode>);

// Registered only in production — required for Chrome's "Add to Home
// Screen" install prompt (see InstallPrompt.jsx / service-worker.js).
// Skipped in dev so it never fights CRA's own dev-server/HMR requests.
if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').catch(() => { /* install prompt just won't show — non-fatal */ });
    });
}
